export default __webpack_public_path__ + "static/media/s2.95348c7d.jpg";